// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"ClientesTable_spinnerContainer__ETXHb","botonAdd":"ClientesTable_botonAdd__9eUZe"};